import { cva } from 'class-variance-authority';

import { cn } from '@heidi/utils';

export const comboboxRootClasses = cn('w-60');

// Disabled-state trigger overrides — render as a disabled field, not a disabled outline button:
// - bg-surface-disabled + text-text-disabled — fill + tint so it reads as a disabled field.
// - [&_svg]:text-text-disabled — pin chevron to disabled tint.
// - [&>svg]:opacity-100 — restore chevron to full opacity.
export const comboboxTriggerVariants = cva(
  'w-full justify-between rounded-lg transition disabled:bg-surface-disabled disabled:text-text-disabled disabled:[&>svg]:opacity-100 disabled:[&_svg]:text-text-disabled'
);

export const comboboxTriggerPlaceholderClasses = cn('font-[400] text-text-secondary');

export const comboboxTriggerErrorClasses = cn('text-validation-destructive');

export const comboboxTriggerIconClasses = cn('ms-2 size-4 shrink-0 opacity-50');

export const comboboxLeadingIconClasses = cn(
  'flex shrink-0 items-center [&_svg]:size-4 [&_svg]:shrink-0'
);

export const comboboxContentVariants = cva(
  'max-h-[var(--radix-popper-available-height)] origin-[var(--radix-popover-content-transform-origin)] p-0'
);

export const comboboxCommandClasses = cn('rounded-lg');

export const comboboxCommandInputClasses = cn('h-9');

export const comboboxItemVariants = cva(
  'rounded-md py-2 hover:bg-surface-hover hover:text-text-primary active:bg-surface-pressed'
);

export const comboboxItemLabelWithIconClasses = cn('ms-2');

export const comboboxCheckIconClasses = cn('ms-auto size-4');

export const comboboxMultiItemDisabledClasses = cn('cursor-not-allowed opacity-50');

export const comboboxMultiCheckboxClasses = cn('pointer-events-none mt-0.5');

export const comboboxMultiItemBodyClasses = cn('flex min-w-0 flex-col gap-0.5');

export const comboboxErrorMessageClasses = cn('mt-1 text-validation-destructive');
